import React from 'react';
import App from './App';

import { createRoot } from 'react-dom/client';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if use TypeScript

// root.render(<App tab="home" />);
root.render(<App  tab="home" />);